<template>
  <div>
  <q-dialog
    ref="consumerUnitAddressModal"
  >
    <q-layout
      view="Lhh lpR fff"
      container
      class="bg-white modal-large consumerUnitAddressContainer"
    >
      <q-header class="bg-primary">
        <q-toolbar>
          <q-toolbar-title>
            <q-icon name="library_add" size="25px" class="q-pr-sm" />
            {{ $gettext(computedTitle) }}
          </q-toolbar-title>
          <q-btn flat @click="hide">
            <q-icon name="cancel" size="2.5em"/>
          </q-btn>
        </q-toolbar>
      </q-header>
      <jt-dynamic-form
        v-if="renderForm"
        ref="compositionForm"
        :inputs="form.inputs"
        :interface="form.nmInterface"
        :relacionamentos="form.relacionamentos"
        :model="form.dadosForm"
        form-class="form"
        class="q-pa-lg formContainer consumerUnitAddressForms"
        @search-found="selections"
      />
      <div class="row q-col-gutter-x-lg q-col-gutter-y-xs q-px-lg">
        <q-input v-model="form.dadosForm.latitude"  :label="$gettext('LATITUDE')" outlined type="text" class="col-3" name="latitude" readonly />
        <q-input v-model="form.dadosForm.longitude" :label="$gettext('LONGITUDE')" outlined type="text" class="col-3 q-pl-lg" name="longitude" readonly />
        <q-btn icon="pin_drop" @click="openMap" flat label="Visualizar Mapa"></q-btn>
      </div>
      <section
        class="row justify-center full-width q-gutter-md q-pa-lg sectionConsumerUnitAddress"
      >
        <div
          v-for="(button, index) in form.buttons"
          :key="index"
          class="col-2 buttonsConsumerUnitAddress"
        >
          <q-btn
            class="full-width"
            color="positive"
            :name="button.name"
            @click="onFormButtonClickHandler(button)"
            >{{ button.label }}
          </q-btn>
        </div>
      </section>
    </q-layout>
  </q-dialog>
  <map-modal @close-modal="closeMapModal"  v-if="renderMap" @on-coordinate-change="onCoordinateChange" v-bind="{...form.dadosForm}" :renderMap="renderMap" ref="mapModal" />
  </div>
</template>
<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { JtDynamicForm, JtCompositionFormModal, JtForm, JtInput } from 'jtech-webcomps'
import { repository } from 'jtech'
import MapModal from './MapModal.vue'

@Component({
  mixins: [JtCompositionFormModal],
  components: {
    JtDynamicForm,
    'jt-input': JtInput,
    JtForm,
    MapModal
  },
  props: {
    form: {
      type: Object,
      required: true
    },
    composicaos: {
      type: Array,
      required: false
    },
    defaultLocation: {
      type: Object,
      default: () => ({
        lat: 51.505,
        lng: -0.159
      })
    },
    nrLinhaSelecionada: Number,
    flComposicaoAlteracao: Boolean
  }
})
class ConsumerUnitAddress extends Vue {
  renderForm = false;
  renderMap = false;
  formModel = {};

  show () {
    this.renderForm = true
    this.form.inputs = this.form.inputs.filter((i) => i.type != 'COMPOSICAO')
    this.formModel = this.form.dadosForm

    this.$refs.consumerUnitAddressModal.show()
  }

  hide () {
    this.$refs.consumerUnitAddressModal.hide()
  }

  openMap () {
    this.renderMap = true
  }

  closeMapModal () {
    this.renderMap = false
    setTimeout(() => { this.$refs.consumerUnitAddressModal.show() }, 100)
  }

  onCoordinateChange ({ latitude, longitude }) {
    this.formModel.latitude = latitude
    this.formModel.longitude = longitude
  }

  get foorf () {
    return this.form
  }

  created () {
  }

  async selections (data) {
    if (data.address.idField) {
      const param = { id: data.address.idField }
      const { registros } = await repository.resolveDatatableModel(
        'address.pesquisarSelecao',
        param
      )

      this.$nextTick(() => {
        this.form.dadosForm.address = data.address.idField
        this.$set(this.form.dadosForm, 'zipCode', registros[0].zipCode)
        this.$set(
          this.form.dadosForm,
          'neighborhood',
          registros[0].neighborhood
        )
        this.$set(this.form.dadosForm, 'city', registros[0].city)
        this.$set(this.form.dadosForm, 'state', registros[0].state)
        this.$set(this.form.dadosForm, 'country', registros[0].country)
      })
    }
  }

  setEditable (object) {
    if (object.id) object.flAlterado = 'S'
  }

  onFormButtonClickHandler (button) {
    if (button.name == 'btClose') {
      this.hide()
    } else if (button.name == 'btAlterar' || button.name == 'btGravar') {
      this.$emit('save-address', { data: this.formModel, buttonName: button.name })
    }
    if (button.name === 'btSalvarComposicao') {
      // this.formModel.latitude = this.position.latitude
      // this.formModel.longitude = this.position.longitude
      this.__saveButtonHandler({ button, fields: this.formModel })
    } else if (button.name === 'btFecharComposicao') this.hide()
  }
}

export default ConsumerUnitAddress
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

.consumerUnitAddressContainer {
  border-radius: 0px !important;
}

.consumerUnitAddressForms {
  #scroll-area {
    height: calc(35vh - 12px) !important;
  }
}

.sectionConsumerUnitAddress {
  .buttonsConsumerUnitAddress:first-child {
    .q-btn {
      background: #A9B9C2 !important;
      color: black;
    }
  }
}

@media only screen and (max-height: 765px) {
  .consumerUnitAddressForms {
    #scroll-area {
      height: calc(30vh - 12px) !important;
    }
  }
}

</style>
